/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Euroclass code
 * @export
 * @interface MonitoredObjectMetadataProfileMergedItemCharField
 */
export interface MonitoredObjectMetadataProfileMergedItemCharField {
    /**
     * 
     * @type {boolean}
     * @memberof MonitoredObjectMetadataProfileMergedItemCharField
     */
    md: boolean;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectMetadataProfileMergedItemCharField
     */
    v?: string;
}

export function MonitoredObjectMetadataProfileMergedItemCharFieldFromJSON(json: any): MonitoredObjectMetadataProfileMergedItemCharField {
    return MonitoredObjectMetadataProfileMergedItemCharFieldFromJSONTyped(json, false);
}

export function MonitoredObjectMetadataProfileMergedItemCharFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectMetadataProfileMergedItemCharField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'md': json['md'],
        'v': !exists(json, 'v') ? undefined : json['v'],
    };
}

export function MonitoredObjectMetadataProfileMergedItemCharFieldToJSON(value?: MonitoredObjectMetadataProfileMergedItemCharField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'md': value.md,
        'v': value.v,
    };
}


